import { useQuery } from '@apollo/client';
import { WorldMapView, WorldMapViewVariables } from 'graphql/query/__generated__/worldMapView';
import { WORLD_MAP_VIEW_QUERY } from 'graphql/query/worldQuery';
import { useViewMapQueryParams } from 'hooks/map/useViewMapQueryParams';
import { useWorldMapLocalStorage } from 'libs/hooks/ownership/useWorldMapLocalStorage';
import { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router';
import { CtxView } from 'session/ctxView';

export const useLoadMap = (mapId: string, opts: { skip: boolean }) => {
    const { getTokenForMapId } = useWorldMapLocalStorage();
    const params = useViewMapQueryParams();
    const ctxView = useContext(CtxView);
    const navigate = useNavigate();
    const map = useQuery<WorldMapView, WorldMapViewVariables>(WORLD_MAP_VIEW_QUERY, {
        variables: {
            worldMapId: mapId,
            token: getTokenForMapId(mapId),
            initialLoad: true,
            language: params.language
        },
        skip: opts.skip,
        fetchPolicy: 'network-only',
        onError: (error) => {
            if (error && error.message.includes('MAP_BLOCKED')) {
                navigate('/map-blocked');
            }

            if (error && error.message.includes('Not Found')) {
                console.log('Not found error');
                navigate('/admin');
            }
        }
    });

    useEffect(() => {
        if (map.data?.worldMapView) {
            ctxView.setMap(map.data.worldMapView);
            const worldMapSets = map.data?.worldMapView.worldMapSets ?? [];
            const visibleSetIds = worldMapSets
                .filter((e) => e.isVisibleOnLoad)
                .map((e) => e.worldMapSetId);

            ctxView.setVisibleMapSetIds(visibleSetIds);
        }
    }, [map.data?.worldMapView?.worldMapId, mapId]);
};
